module.exports = __webpack_public_path__ + "64a4a49ea0686fce389759b853896453.jpeg";